// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_styles_footer__FcQ2y"};